import { OrderOperations } from "./OrderOperations"
import { OrderRelease } from "lib/types/generated/graphql-types"

export class Release extends OrderOperations {
  constructor(release: OrderRelease[]) {
    super(release)
  }

  public completedReleases(): OrderRelease[] {
    return this.completedList() as OrderRelease[]
  }

  public getPendingRelease(): OrderRelease {
    const pendingList = this.pendingList() as OrderRelease[]
    return pendingList[0]
  }

  public failedReleases(): OrderRelease[] {
    return this.failedList() as OrderRelease[]
  }

  public orderLineReleased(orderLineId: string): OrderRelease | undefined {
    return this.completedReleases().find((release) =>
      release.orderLines.find((ol) => ol.orderLineId === orderLineId)
    )
  }
}
